import EntrepriseCard from "./EntrepriseCard/EntrepriseCard";
import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Loader from "Components/Loader/loader";
import { Toast } from "primereact/toast";
import "./EntreprisesPartenaires.scss";
import { updatePagination } from "Redux/Actions/paginationActions";
import { useState } from "react";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import axios from "axios";

const EntreprisesPartenaires = (props) => {
  const companyRef = useRef(null);
  const uploadToast = useRef(null);
  const cancelToast = useRef(null);
  const [urlCompany, setUrlCompany] = useState("");
  const [triggerQuery, setTriggerQuery] = useState(false);
  const companiesQuery = useFetchGetPagination(urlCompany, props.auth.token);

  useEffect(() => {
    let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/companies`);
    if (props.orderPartner === "Partner") url.searchParams.set("isPartner", 1);
    else if (props.orderPartner === "Not Partner")
      url.searchParams.set("isPartner", 0);
    else url.searchParams.set("order[isPartner]", "desc");

    props.isFilteringKeyword &&
      url.searchParams.set("keyword", props.filtreMotsCles);

    setUrlCompany(url);
  }, [props.orderPartner, props.isFilteringKeyword, triggerQuery]);

  const changePartnerStatus = (company) => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/companies/${company.id}`;
    axios
      .put(
        url,
        { isPartner: !company.isPartner },
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        }
      )
      .then((res) => {
        setTriggerQuery(!triggerQuery);
        if (res.data.isPartner) {
          uploadToast.current.show({
            severity: "success",
            summary: "Succès : ",
            detail:
              "L'entreprise a bien été ajoutée aux entreprises partenaires",
            life: 3000,
          });
        } else {
          cancelToast.current.show({
            severity: "error",
            summary: "Suppression : ",
            detail:
              "L'entreprise a bien été retirée des entreprises partenaires",
            life: 3000,
          });
        }
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };

  return (
    <div className="partner_companies">
      <div className="companies_container">
        <Toast ref={uploadToast} />
        <Toast ref={cancelToast} />
        {companiesQuery.loaded && companiesQuery?.data?.length > 0 ? (
          companiesQuery.data.map((company, index) => (
            <EntrepriseCard
              key={index}
              nomEntreprise={company.name}
              type={
                company.structure ? company.structure.label : company.type.label
              }
              imageLogo="logoOffre1"
              imageFond="entrepriseFond1"
              taille={
                company.totalStaff ? company.totalStaff.label : "Non renseigné"
              }
              offresDisponibles={true}
              isPartner={company.isPartner}
              companyId={company.id}
              uploadToast={uploadToast}
              cancelToast={cancelToast}
              fromGestion={true}
              changePartnerStatus={() => changePartnerStatus(company)}
            ></EntrepriseCard>
          ))
        ) : props.filtreMotsCles !== "" ||
          props.orderPartner === "Partner" ||
          props.orderPartner === "Not Partner" ? (
          <span>Aucune entreprise ne correspond à votre recherche</span>
        ) : (
          <Loader></Loader>
        )}
      </div>
      <TempPagination
        result={companiesQuery}
        refItemParent={companyRef}
        rows={50}
      />
    </div>
  );
};

EntreprisesPartenaires.propTypes = {
  auth: PropTypes.object,
  companies: PropTypes.object,
  filtreMotsCles: PropTypes.any,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  orderPartner: PropTypes.object,
  isFilteringKeyword: PropTypes.bool,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  companies: state.companies,
  pagination: state.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => dispatch(updatePagination(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EntreprisesPartenaires);
